module.exports = __webpack_public_path__ + "img/collection-engagementRings050Carat.d085ffe.jpg";